<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <ap-field
    [title]="'internalUser.email' | translate"
    [required]="true"
    [error]="emailField.touched && !!emailField.errors">
    <input appkit-field formControlName="email" />
    @if (emailField.touched && emailField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (emailField.touched && emailField.errors?.['email']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.email' | translate }}
      </div>
    }
  </ap-field>

  <ap-field
    [title]="'internalUser.firstName' | translate"
    [required]="true"
    [error]="firstNameField.touched && !!firstNameField.errors">
    <input
      appkit-field
      formControlName="firstName"
      [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - firstNameField.value.length }
      }}
    </div>
    @if (firstNameField.touched && firstNameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (firstNameField.touched && firstNameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{
          'form-validation-messages.alphabeticCharacters'
            | translate: { fieldName: 'First Name' }
        }}
      </div>
    }
  </ap-field>

  <ap-field
    [title]="'internalUser.lastName' | translate"
    [required]="true"
    [error]="lastNameField.touched && !!lastNameField.errors">
    <input
      appkit-field
      formControlName="lastName"
      [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - lastNameField.value.length }
      }}
    </div>
    @if (lastNameField.touched && lastNameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (lastNameField.touched && lastNameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{
          'form-validation-messages.alphabeticCharacters'
            | translate: { fieldName: 'Last Name' }
        }}
      </div>
    }
  </ap-field>

  <ap-checkbox formControlName="isActive" class="mt-2">
    {{ 'client.isActive' | translate }}
  </ap-checkbox>

  <div class="mt-3 d-flex flex-column gap-1">
    <span class="ap-pattern-form-required-indicator">{{
      'internalUser.roles' | translate
    }}</span>
    @for (userRole of userRoles(); track userRole.id) {
      <ap-checkbox
        (onChange)="hasRoleSelected()"
        [formControl]="userRolesRecord.controls[userRole.id]"
        class="mt-2">
        {{ userRole.name | parseToSentenceCase }}
      </ap-checkbox>
    }
    @if (isCountryAdminSelected()) {
      <div
        formArrayName="countryAssignments"
        class="mt-2 d-flex flex-column gap-1">
        <gstar-countries-combobox
          [title]="'internalUser.countryAdminCountry' | translate"
          (selectCountry)="countrySelect($event)" />
        @for (assignmentControl of countryAssignments.controls; track $index) {
          <div class="ap-mb-spacing-4 d-flex" [class.mt-3]="$index === 0">
            <ap-field [hidden]="true">
              <input appkit-field [formControlName]="$index" />
            </ap-field>
            <div class="me-auto">
              <div class="d-flex align-items-center">
                <ap-avatar
                  diameter="40"
                  borderWidth="0"
                  [name]="assignmentControl.value?.name?.charAt(0) ?? ''"
                  [disabled]="true"></ap-avatar>
                <span class="ap-ml-spacing-4">
                  {{ assignmentControl.value?.name ?? '' }}
                </span>
              </div>
            </div>
            <div>
              <button
                type="button"
                (click)="removeCountry($index)"
                class="Appkit4-icon icon-delete-outline">
                &nbsp;
              </button>
            </div>
          </div>
        }
      </div>
      @if (!isCountrySelectionValid()) {
        <div class="ap-field-validation-error">
          {{ 'formValidations.required' | translate }}
        </div>
      }
    }
    @if (!hasRoleSelected()) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
  </div>

  <ap-checkbox formControlName="rolesChecked" class="d-none"> </ap-checkbox>
</form>
